module.exports = __webpack_public_path__ + "media/hemorrhagic gastritis.5b900cef.wav";